// MUI
import ErrorComponent from "../components/404ErrorComponent";

const ErrorPage: React.FC = () => {
  return <ErrorComponent error={{}} resetErrorBoundary={() => {}} />;
};

export const config = {
  private: false,
};

export default ErrorPage;
